module.exports = __webpack_public_path__ + "static/media/nauka-programowania-dla-dzieci-inf3-3.683ff693.png";